/* eslint-disable max-lines */
/* eslint-disable max-len */

import TableList from '@/inheritance/table-list';

export default {
  /**
   * Nombre del componente
   */
  name: 'OperationsList',

  /**
   * Extendemos la funcionalidad del listado de tablas desde src/inheritance/table-list.js
   */
  extends: TableList,

  /**
   * @override
   */
  props: {
    id: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false
    }
  },

  /**
   * @override
   */
  data() {
    return {
      defaultColumns: [
        'id_object',
        'name_product',
        'request_date',
        'operation_date',
        'nav_date',
        'key_operation_type',
        'key_sub_operation_type',
        'shares',
        'nav',
        'gross_amount',
        'net_amount',
        'operation_issues_count',
        // COMENTADOS los campos de conciliación: YURI-2386
        // 'reconciliation_status',
        'operation_status',
        'interveners',
        'external_code'
      ],
      listSearching: false,
      downloadingDocuments: [],
      loading: false,
      selectedOperationToCancel: null
    };
  },

  methods: {
    rowCanBeValidated(row) {
      const status = row.operation_status;
      const isRegistered = status.includes('REGISTERED');
      const isNotRegisteredPostal = status !== 'REGISTERED_POSTAL';
      const isSigned = status === 'SIGNED';
      return (
        (row.can_be_validated && ((isRegistered && isNotRegisteredPostal) || isSigned)) ||
        (row.has_docs_been_downloaded && (isRegistered || isSigned))
      );
    },
    canRowDisplayContextMenu(row) {
      return (
        row.can_be_validated ||
        row.operation_status === 'SIGNED' ||
        row.operation_status.includes('REGISTERED') ||
        (this.$refs.table && this.$refs.table.isAllowedToExecuteBatchDownloads)
      );
    },
    /**
     * Obtenemos la lista de cuentas desde el servicio
     * @param {String} sort Orden asc/desc
     * @param {Object} cfg Configuración de filtros
     */
    loadItems(sort = this.orderby, cfg = {}) {
      if (this.filters && Object.keys(this.filters).length) {
        cfg.params = {
          $filter: JSON.stringify(this.filters)
        };
      }

      const payload = {
        section: 'operations',
        cfg
      };

      if (sort && sort !== 'false') {
        payload.sort = sort;
      }

      this.listSearching = true;
      this.loadData(payload)
        .then(res => {
          this.metadata = res.metadata;
          res.data.operations = res.data.operations.map(operation => {
            operation.uuid = operation.operation_id;
            return operation;
          });
          this.items = this.mapSelfName(res.data.operations, ['id_object']);
          this.getColumns();
          this.filterColums();
          const changedColumns = this.loadFilterInLocalstore('col_oper');
          if (!changedColumns.length) {
            this.orderColumns();
          }
          this.calculateColumnsWith(this.columns);
        })
        .catch(err => this.$toast.error(`Error Operations List ${err.name}`, `${err.message}`))
        .finally(() => {
          this.listSearching = false;
          this.$nextTick(() => {
            if (!this.tableHasScroll()) {
              this.infiniteScroll();
            }
          });
        });
    },

    /**
     * @override
     */
    colsChange(cols) {
      this.columns = cols;
      this.saveFilterInLocalstore(cols, 'col_oper');
    },

    /**
     * Ordenamos la tabla por un campo específico
     * @param {String} field Orden de la tabla
     */
    sort(field) {
      this.orderby = field;
      let cfg = {};

      if (this.filters && Object.keys(this.filters).length) {
        cfg = {
          params: {
            $filter: JSON.stringify(this.filters)
          }
        };
      }
      if (field && field !== 'false') {
        this.saveFilterInLocalstore(field, 'ob_oper');
      } else {
        this.removeFromLocalstore('ob_oper');
      }
      this.loadItems(field, cfg);
    },

    /**
     * FILTRO DE RESULTADOS
     * Aplicamos los filtros seleccionados. Guardamos en localStore una variable con los filtros aplicados,
     * para que cuando el usuario cambie de sección y vuelva de nuevo a este listado, se carguen
     * los resultados que había filtrado.
     * @param {Array} filters Filtros para aplicar
     */
    filter(filters) {
      if (!this.id) {
        this.saveFilterInLocalstore(filters, 'filt_oper');
      }
      if (filters.length >= 1) {
        this.tbFilters = filters;
        this.applyFilters(filters);
        const cfg = {
          params: {
            $filter: JSON.stringify(this.filters)
          }
        };
        this.loadItems(this.orderby, cfg);
      } else {
        delete this.filters;
        this.loadItems();
      }
    },

    /**
     * SCROLL INFINITO
     * Método que se ejecuta cuanto el usuario ha hecho scroll y ha llegado al final de la tabla.
     * Se llama al método heredado 'pagination' y devuelve un array de resultados, los cuales
     * se 'mezclan' con los resultados que tenía la tabla.
     */
    infiniteScroll() {
      if (this.listSearching) {
        return;
      }
      const payload = {
        section: 'operations',
        href: this.metadata.paging._links._next.href
      };
      if (payload.href && !this.isLoading) {
        this.pagination(payload)
          .then(res => {
            res.data.operations = res.data.operations.map(operation => {
              operation.uuid = operation.operation_id;
              return operation;
            });
            this.metadata = res.metadata;
            this.items = [...this.items, ...this.loadDataInTable(res.data.operations, ['id_object'])];
          })
          .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`));
      }
    },
    /**
     * Añade los filtros obtenidos de localStorage a la petición inicial
     * @param {Object} tbFilters filtros guardados en storage
     */
    addFiltersToRequest(tbFilters) {
      // Se añaden los filtros a la petición si están en el storage
      this.filters = [];
      tbFilters.forEach(filtro => {
        const condition = filtro.condition;
        this.filters.push({
          field: filtro.field,
          condition,
          conditionValue: filtro.conditionValue,
          orFilter: !!filtro.orFilter
        });
      });
      this.applyFilters(this.filters);
    },

    doSearch(val) {
      this.search = val;
      this.saveFilterInLocalstore(val, 'search_oper');
      this.loadItems();
    },
    validateOperation(operation) {
      this.loading = true
      // Si es operación periódica, cambiar directamente a PERIODIC_ACTIVE
      const PERIODIC_OPERATION_TYPES = [
        'SOLICITUD_SUSCRIPCION_PERIODICA',
        'SOLICITUD_REEMBOLSO_PERIODICO',
        'SOLICITUD_APORTACION_PERIODICA',
        'SUSCRIPCION_PERIODICA',
        'REEMBOLSO_PERIODICO',
        'APORTACION_PERIODICA'
      ];
      const isPeriodic = PERIODIC_OPERATION_TYPES.includes(operation.key_operation_type);
      const status = isPeriodic ? 'PERIODIC_ACTIVE' : 'VALIDATED';

      this.$operationsService
        .changeOperationStatus(operation.uuid, { status })
        .then(response => {
          this.$toast.success(`Ok`, `${operation._self_name} validada correctamente`);
          if (response.data.operationIssueMessage) {
            this.$toast.success(`Nuevo caso`, response.data.operationIssueMessage, 20000);
          }
          this.loadItems();
        })
        .catch(() => {
          this.$toast.error(`Error`, `Error al validar a ${operation._self_name}`);
        })
        .finally(() => this.loading = false)
    },
    async sendOperationToRD(operation) {
      // Si no está validada no debería hacer nada (por seguridad, pero no debería mostrarse el botón)
      if (operation.operation_status !== 'VALIDATED') {
        return;
      }

      // Las operaciones periódicas NUNCA se envían a RD
      const PERIODIC_OPERATION_TYPES = [
        'SOLICITUD_SUSCRIPCION_PERIODICA',
        'SOLICITUD_REEMBOLSO_PERIODICO',
        'SOLICITUD_APORTACION_PERIODICA',
        'SUSCRIPCION_PERIODICA',
        'REEMBOLSO_PERIODICO',
        'APORTACION_PERIODICA'
      ];
      if (PERIODIC_OPERATION_TYPES.includes(operation.key_operation_type)) {
        return;
      }

      // antes de enviar, actualizamos la fecha y si está todo OK se envía
      try {
        await this.$operationsService.updateOperation(operation.uuid, {
          operation_date: this.$moment(new Date()).format('YYYY-MM-DD')
        });

        await this.$operationsService.changeOperationStatus(operation.uuid, {
          status: 'RD_SENT',
          sendToRD: true
        });
        this.$toast.success('OK', 'Enviado a RD correctamente');
        this.loadItems();
      } catch (err) {
        this.$toast.error(`Error ${err.name}`, `${err.message}`);
      }
    },
    showCancelModal(operation) {
      this.selectedOperationToCancel = operation;
      this.$bvModal.show('modalCancelOperation');
    },
    rowCanBeCancelled(row) {
      const notAllowedStatuses = ['RD_SENT', 'CANCELLED', 'FINALIZED']
      const isExternalTransferSent = 
        row.key_operation_type === 'SOLICITUD_TRASPASO_EXTERNO_ENTRADA' &&
        row.operation_status === 'RD_SENT';
      return !notAllowedStatuses.includes(row.operation_status) || isExternalTransferSent;
    },
    cancelOperation() {
      if( !this.selectedOperationToCancel ) return

      this.$operationsService
        .changeOperationStatus(this.selectedOperationToCancel.uuid, { status: 'CANCELLED' })
        .then(() => {
          this.$bvModal.hide('modalCancelOperation');
          this.$toast.success(`Ok`, `${this.selectedOperationToCancel._self_name} anulada correctamente`);
          this.loadItems();
        })
        .catch(() => {
          this.$toast.error(`Error`, `Error al anular ${this.selectedOperationToCancel._self_name}`);
        });
    },
    cancelCancelOperation() {
      this.$bvModal.hide('modalCancelOperation');
      this.selectedOperationToCancel = null;
    },
    filterColums() {
      this.columns = this.columns.filter(col => {
        return ![
          'account_id',
          'alias_account',        
          'commission',
          'expires_on',
          'fiscal_amount',
          'key_product',
          'operation_id',
          'uuid',
          'uuid_distributor',
          'uuid_owner',
          'uuid_request',
          'uuid_subdistributor',
          'parent_product_name',
          'pp_compartment',
          'pp_plan_type',
          'pp_redemption_cause',
          'pp_redemption_collection_method',
          'pp_redemption_defer',
          'pp_redemption_entitlement_date',
          'pp_redemption_rendering_variation',
          'pp_redemption_rendering_variation_date',
          'pp_redemption_rendering_variation_type',
          'pp_rights_type',
          'pp_source_situation',
          'pp_source_situation',
          'pp_xt_dgs_code',
          'pp_xt_egs_code',
          'reconciliation_status',
        ].includes(col.field);
      });
    },
    orderColumns() {
      const columnsOrdered = [];
      const columnsOrder = [
        'id_object',
        'name_product',
        'request_date',
        'operation_date',
        'nav_date',
        'key_operation_type',
        'key_sub_operation_type',
        'shares',
        'nav',
        'gross_amount',
        'net_amount',
        'operation_issues_count',
        'reconciliation_status',
        'operation_status',
        'interveners',
        'account_id_object',
        'currency',
        'commission',
        'amount_shares_indicator',
        'pay_method',
        'withholding',
        'external_code',
        'user_owner',
        'is_total_redemption',
        'is_total_transfer',
        'can_be_sent_to_rd',
        'can_be_validated',
        'has_docs_been_downloaded',
        'is_deleted',
        'is_private',
        'is_request',
        'is_periodic',
        'per_end_date', 
        'per_increase', 
        'per_increase_period', 
        'per_increase_type', 
        'per_start_date', 
        'pp_compartment',
        'pp_plan_type',
        'pp_redemption_cause',
        'pp_redemption_collection_method',
        'pp_redemption_defer',
        'pp_redemption_entitlement_date',
        'pp_redemption_rendering_variation',
        'pp_redemption_rendering_variation_date',
        'pp_redemption_rendering_variation_type',
        'pp_rights_type',
        'pp_source_situation',
        'pp_xt_dgs_code',
        'pp_xt_egs_code',
        'ind_percepcion_pres',
        'ind_tipo_pres',
        'transfer_nav_on_month_end',
        'name_target_product',
        'xt_acount_origin',
        'xt_fund_name',
        'xt_fund_nif',
        'xt_fund_official_reg_number',
        'xt_gestor',
        'xt_gestor_nif',
        'xt_gestor_official_reg_number',
        'xt_isin_code',
        'xt_provider',
        'xt_provider_nif',
        'xt_provider_official_reg_number'
      ];
      for (let index = 0; index < columnsOrder.length; index++) {
        const c = this.columns.find(x => x.name === columnsOrder[index]);
        if (c) {
          columnsOrdered.push(c);
        }
      }
      this.columns = columnsOrdered;
    },
    handleLoadView(view) {
      this.filters = null;
      this.tbFilters = [];
      this.orderby = '';
      this.removeFromLocalstore('filt_oper');
      this.removeFromLocalstore('ob_oper');
      this.removeFromLocalstore('col_oper');
      this.removeFromLocalstore('search_oper');
      this.loadView(view);
    }
  },
  /**
   * @override
   */
  beforeMount() {
    this.section = 'operations';
    this.loadSectionViews();
  },

  /**
   * Configuración inicial del componente
   * 1. Asignamos las columnas por defecto del listado de la tabla
   * 2. Obtenemos los filtros que el usuario pueda haber aplicado con anterioridad
   * 3. Obtenemos la información de la tabla
   */
  mounted() {
    this.$root.$off('downloading');
    this.$root.$on('downloading', uuids => {
      this.downloadingDocuments = uuids;
    });
    this.$root.$off('updateItems');
    this.$root.$on('updateItems', () => {
      this.loadItems();
      this.downloadingDocuments = [];
    });

    if (this.id && this.type) {
      let field;
      switch (this.type) {
        case 'account':
          field = 'account_id';
          break;
        case 'intervener':
          field = 'uuid_intervener';
          break;
        case 'periodic_operation_request':
        case 'operation_request':
          field = 'uuid_request';
          break;
        default:
          break;
      }
      if (field) {
        const filter = {
          field,
          condition: 'eq',
          conditionValue: this.id
        };
        this.tbFilters = [filter];
        this.applyFilters(this.tbFilters);
      }
      this.loadItems();
    } else {
      this.tbFilters = this.loadFilterInLocalstore('filt_oper');
      this.orderby = this.loadFilterInLocalstore('ob_oper');
      this.search = this.loadFilterInLocalstore('search_oper');

      this.addFiltersToRequest(this.tbFilters);

      const storedView = JSON.parse(localStorage.getItem(`table_view_selected_${this.$route.name}`));
      if (storedView) {
        this.loadView(storedView);
      } else if (
        this.orderby &&
        this.orderby !== 'false' &&
        this.orderby.length > 0 &&
        this.orderby !== this.$route.query['sorts-by']
      ) {
        this.$router
          .replace({
            path: this.$route.fullPath,
            query: { 'sorts-by': this.orderby }
          })
          .then(() => {
            this.sort(this.orderby);
          });
      } else {
        this.loadItems();
      }

      this.columns = this.loadFilterInLocalstore('col_oper');
    }
  },
  beforeDestroy() {
    this.$root.$off('updateItems');
    this.$root.$off('downloading');
  }
};
